import Cookies from 'js-cookie'
import { COBRAND_QUERY_NAME } from '@/lib/constants/cobrands.js'

// Cookies we're allowed to set from the Query, and the values we're allowed to set them to
const safelist = {
  credit_checkout: [true, false],
}

/**
 * Helper function to transform data.
 *
 * EG convert string 'true' to Boolean True.
 */
function transform(value) {
  if (value === 'true' || value === '1') {
    return true
  }

  if (value === 'false' || value === '0') {
    return false
  }

  return value
}

/**
 * Set a Cookie from the Route Query if it's in the Safelist.
 */
export function setCookieFromQuery(query) {
  Object.entries(query).forEach(([name, value]) => {
    // if the cookie is for cobrand, set it regardless of the value
    if (name === COBRAND_QUERY_NAME) {
      Cookies.set(name, value)
    }

    // Make sure our value is the correct Type
    const val = transform(value)

    // If our name is in the Safelist and the value is allowed
    if (name in safelist && safelist[name].includes(val)) {
      Cookies.set(name, val)
    }
  })
}
